"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YoutubeSlide = YoutubeSlide;
exports.ImageSlide = ImageSlide;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _utils = require("../utils");

var _youtube = require("../youtube");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      width: '100%',
      height: '100%',
      ' &>div': {
        width: '100%',
        height: '100%'
      }
    }
  };
}); // Since youtube slide is our internal thing we don't really need to add strict types to it
// eslint-disable-next-line react/prop-types

function YoutubeSlide(_ref) {
  var isActive = _ref.isActive,
      setZoom = _ref.setZoom,
      url = _ref.url,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["isActive", "setZoom", "url", "title"]);

  var styles = useStyles();
  var query = (0, _react.useMemo)(function () {
    return (0, _utils.parseUrlQuery)(url);
  }, [url]);
  (0, _react.useLayoutEffect)(function () {
    // disable image zoom if youtube video is playing
    setZoom(!isActive);
  }, [isActive]);
  return /*#__PURE__*/_react.default.createElement("div", _extends({}, rest, {
    className: styles.root
  }), /*#__PURE__*/_react.default.createElement(_youtube.YouTubePlayer, {
    title: title,
    id: query.v,
    key: String(isActive)
  }));
} // eslint-disable-next-line react/prop-types


function ImageSlide(_ref2) {
  var url = _ref2.url,
      _ref2$alt = _ref2.alt,
      alt = _ref2$alt === void 0 ? '' : _ref2$alt,
      props = _objectWithoutProperties(_ref2, ["url", "alt"]);

  return /*#__PURE__*/_react.default.createElement("img", _extends({}, props, {
    alt: alt,
    src: url
  }));
}